import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import MoModalVeteranReviewCreateTeamStore from './store';

const styles = require('./index.less');

const MoModalVeteranReviewCreateTeam = ({ className, store, onClose }) => {
  store.use({ appendCloseCallback: onClose });
  const submitting = store.submitting === true;

  return (
    <ModalContainer modalState={store.isOpen} aria-busy={submitting}>
      <div className={cx(styles.root, className)}>
        <div className={styles.group1} data-name="MO-回顾页-无队伍分支确认建队弹窗">
          <div className={styles.layer1} data-name="弹窗背景" />
          <button className={cx(styles.layer2, styles.action)} data-name="关闭" disabled={submitting} onClick={store.onClickClose} type="button">
            <span className={styles.semanticText}>关闭</span>
          </button>
          <div className={styles.group2} data-name="弹窗主体">
            <div className={styles.group3} data-name="按钮区">
              <button
                className={cx(styles.layer3, styles.action)}
                data-name="仅生成海报按钮"
                disabled={submitting}
                onClick={store.handleContinueWithoutTeam}
                type="button"
              >
                <span className={styles.semanticText}>仅生成海报</span>
              </button>
              <button
                className={cx(styles.layer4, styles.action)}
                data-name="创建队伍按钮"
                disabled={submitting}
                onClick={store.handleCreateTeam}
                type="button"
              >
                <span className={styles.semanticText}>创建队伍</span>
              </button>
            </div>

            <div
              className={styles.layer5}
              data-name="已为您生成江湖名帖，但少侠尚未组建 公测同游队伍，是否自动创建？"
              data-text="已为您生成江湖名帖，但少侠尚未组建
公测同游队伍，是否自动创建？"
            >
              已为您生成江湖名帖，但少侠尚未组建&#10;公测同游队伍，是否自动创建？
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(MoModalVeteranReviewCreateTeam, MoModalVeteranReviewCreateTeamStore);
